
let global = {g_userInfo:null}
/**
 * 用户信息
 */
export default {
    g_isFirstRun:false,
    g_userInfo: undefined,
    g_dateFormat:"yyyy-MM-dd",
    g_arraySvg:[],
    g_isPresentMode:false,
    g_isFirstShowAttrDialog:false,
    g_currentPageData:{},
    g_currentNoteData:{},
    g_currentNoteType:'',
    g_isDialogNoteIsDrawPage:false,//note是否在draw界面
    g_dialogNoteFrom:'',//note打开的来源
    g_dialogName:'',//当前弹出的对话框名称
    g_currentNoteFullScreen:false,//是否全屏笔记
    g_isNotePopupWindow:false,
    g_arrayFonts:[],
    g_currentSelectMindmap: {},
    g_isDarkMode:false,
    g_projId:'',
    g_isFontColorOpened:false,
    g_isSyncing:false,//正在同步中....
    g_canvasZoomValue:1.0,
    g_edit_md_token:{},
    g_currentDialogName:'',
    g_base_url:'',
    g_isCardUpdate:false,
    g_isRecvDeeplinkMessage:false,//是否收到了electron发送的deeplink消息
    g_isRecvOutOpenAppMessage:false,//是否收到了打开APP登录的消息
    g_openOutData:null,//双击打开的外部数据
    g_isCurrentNoteFullScreenInCanvas:false,//在画布中点击的全屏
    g_isCanvasCardMouseDown:false,
    g_cardMdConvertToken:{},
    g_home_project_count:4,//首页默认数量
    g_isDrawCardUpdate:false,
    g_isDrawCardEditing:false,//是否显示笔记编辑的对话框
    g_isImageActionMouseDown:false,
    g_currentCardEditElement:null,
    g_currentCardEditor:null,
    g_currentSharedProjectId:'',//当前分享的项目ID
    g_currentRecentId:'',//当前打开的项目或卡片的ID
    g_currentBoardId:'',//当前选中的boardId
    g_pasteDeeplinkElement:null,//粘贴的deeplink,
    g_insertPosition:null,//插入的点
    g_defaultStorePath:'',//默认的文件保存路径
    g_appPath:'',//程序路径
    g_handleCardDeeplink:'',//card中的链接 click事件已经处理过的deeplink,
    g_currentDragLibraryItem:null,//当前拖动的库条目
    g_isDragInCard:false,//是拖动到卡片不是画布上的
    g_isRestoreData:false,//如果是恢复的数据，不要保存当前的...
    g_isRefreshLibraryInfoLink:false,//是否需要刷新card界面的info中的link
    g_importFileCount:1,//导入的文件数量
    g_DrawEventXY:{x:0,y:0},
    g_dragPdfAnno:null,
    g_closedId:0,//首页右键关闭的项目/卡片ID
    g_mapCardPos:{},//card和所对应的关闭时的位置
    g_insertMode:'',//插入的模式，有些地方并不能直接传
    g_dialogVideoActiveElement:null,
    // g_openDialogs:{},//当前是否有打开的对话框
    g_hasPinDialog:false,
    g_showDialogs:{},//当前正在显示的对话框  {dialogVideoNotes:false,dialogPdf:false}
    g_isWebDarkMode:false,
    g_isCtrlPressed:false,//按下了ctrl键，
    g_newCardTitle:'',
    g_isAutoRestore:false,//正在从同步的网盘中自动恢复
    g_isDialogLink:false,
    g_isImportProject:false,//正在导入项目
    g_currentTag:'',//当前所选中的tag
    g_isFullscreen:false,
    g_arrayRemovedFromLibraryIds:[],//画布上从库中移除的临时数据，还原的时候用
    g_arrayFavorFolders:[],//收藏文件夹列表
    g_isFontSelectedOpend:false,//mindmap节点是否打开了字体选择。。。
    g_isKeepMindmapToolbarShow:false,//mindmap的各种
    g_currentSelectedText:'',//当前卡片选中的文字
    g_deletedCardIds:{},//已删除的card的ID
    g_copyElement:{},//当前复制的元素。程序内部作一些别的判断吧。
    g_hasFloatWindowHiddenTip:false,
    g_isHiddenAllFloatWin:false,
    g_mapLibraryInfos:{},//记录libraryinfo中的对应关系。不是true的不再查询
    g_projectId:'',
    g_hitElement:null,
    g_elementWithCanvasCache00000:{},
    g_mousedownNode:null,
    g_isLoadingFinished:false,
    g_selectElementIds:[],
    g_tableviewUpdateProperty:false,//是否有更新了property列。
    g_isNewCardInDrawFromC:false,
    g_mArrayOriginSort:{},//原始的排序。不要再刷新了.
    g_webCache:[],//浏览器的缓存页面
    g_test:0,
    g_mapElementHeight:{},
    g_isFromHeadClicked:false,
    g_framePresentList:[],//frame预览列表
    g_arrayTagList:[],//缓存数据库的tag
    g_langCode:'',//语言代码，主要给分享用
    g_isDragFromCardText:false,//从画布上card本身拖动的...
    g_isNotRefreshFavor:false,//不要刷新收藏
    g_pasteEventData: {},//粘贴的数据...
    g_pasteAs:'',//粘贴为---mindmap/text
    g_forceStraight:false,//强制使用直线
    g_mapMdContentCache:{},//md的缓存，画布上的.
};